import RadarOutlinedIcon from '@mui/icons-material/RadarOutlined';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import AdminResourceCrudPage from './components/AdminResourceCrudPage';

const toDate = (value) => {
  if (!value) return '-';
  try {
    return new Date(value).toLocaleString();
  } catch {
    return '-';
  }
};

const AdminOastSessionsPage = () => {
  return (
    <AdminResourceCrudPage
      title="OAST Sessions"
      subtitle="Monitor blind callback sessions and inspect interaction activity across all users."
      icon={RadarOutlinedIcon}
      endpoint="/api/admin/oast-sessions/"
      allowCreate={false}
      allowEdit={false}
      allowDelete={false}
      columns={[
        { key: 'created_at', label: 'Created', render: (row) => toDate(row.created_at) },
        { key: 'user_email', label: 'Owner' },
        { key: 'target_value', label: 'Target' },
        { key: 'scan_type', label: 'Scan Type' },
        { key: 'label', label: 'Label' },
        { key: 'callbacks_count', label: 'Callbacks' },
        {
          key: 'is_active',
          label: 'Active',
          render: (row) => (row.is_active ? 'Yes' : 'No')
        },
        { key: 'last_seen_at', label: 'Last Seen', render: (row) => toDate(row.last_seen_at) }
      ]}
      rowActions={[
        {
          label: 'Events',
          icon: OpenInNewOutlinedIcon,
          visible: (row) => Number(row.callbacks_count || 0) > 0,
          onClick: async (row) => {
            window.open(`/api/admin/oast-sessions/${row.id}/events/`, '_blank', 'noopener,noreferrer');
          }
        },
        {
          label: 'Callback URL',
          icon: OpenInNewOutlinedIcon,
          visible: (row) => Boolean(row.callback_url),
          onClick: async (row) => {
            if (row.callback_url) window.open(row.callback_url, '_blank', 'noopener,noreferrer');
          }
        }
      ]}
    />
  );
};

export default AdminOastSessionsPage;
